import { invert } from 'lodash';
import { screensLandingToInUse } from './screensLandingToInUse';

export const screensInUseToLanding = invert(screensLandingToInUse);
